"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useCallback, useEffect, useState } from 'react';
import { agentCanCopy, setTimeoutWithCallBack } from '../lib';
export const useClipboardCopy = ({
  successMessage: _successMessage = 'Copied!',
  triggerRef,
  stringProvider,
  onFailedCopy,
  onCopied
}) => {
  const [tip, setTip] = useState();
  const onFailed = useCallback(() => {
    setTip('Failed to get copy permission from user machine!');
    if (typeof onFailedCopy === 'function') onFailedCopy();
  }, [onFailedCopy]);
  const onCopyRequest = useCallback(() => {
    (async () => {
      if (!(await agentCanCopy())) return onFailed();
      const clip = stringProvider();
      navigator.clipboard.writeText(await stringProvider()).catch(() => {
        onFailed();
        setTip('Failed to get copy permission from user machine!');
        console.warn(`Failed to copy the following into clipboard: ${clip}`);
      }).then(() => {
        typeof onCopied === 'function' && onCopied();
        setTip(_successMessage);
      });
    })();
  }, [stringProvider, onFailedCopy, onCopied]);
  useEffect(() => {
    let clearCallback;
    if (tip) clearCallback = setTimeoutWithCallBack(() => setTip(null), 3e3);
    return clearCallback !== null && clearCallback !== void 0 ? clearCallback : void 0;
  }, [tip]);
  useEffect(() => {
    if (!(triggerRef !== null && triggerRef !== void 0 && triggerRef.current)) return void 0;
    triggerRef.current.addEventListener('click', onCopyRequest, {
      passive: true
    });
    return () => {
      var _triggerRef$current;
      (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.removeEventListener('click', onCopyRequest);
    };
  }, [triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current, onCopyRequest]);
  return [onCopyRequest, tip];
};